import { useQueries } from '@tanstack/react-query';
import { API_PATIENT_KEY_NOTE } from 'services/dataService/resources';
import { ModuleType } from 'infrastructure/enums';
import QueryParams from 'utils/queryParams';

import { getKeyNotes } from './api/getKeyNoteFn';

interface Props {
  patientGuid?: string;
  module: ModuleType;
  canChangeModule?: boolean;
  showExpired?: boolean;
  enableRPM?: boolean;
  enableCCM?: boolean;
}
export const getKeyNoteKey = ({ patientGuid, module, showExpired }: Props) => [
  'getKeyNoteData',
  patientGuid,
  module,
  showExpired,
];

export const useGetKeyNote = ({
  patientGuid,
  module,
  canChangeModule,
  showExpired,
  enableRPM = true,
  enableCCM = true,
}: Props) => {
  const apiUrl = API_PATIENT_KEY_NOTE(patientGuid);

  const urlRPM = QueryParams.stringifyUrl(apiUrl, {
    module: ModuleType.RPM,
    showExpires: showExpired,
  });
  const urlCCM = QueryParams.stringifyUrl(apiUrl, {
    module: ModuleType.CCM,
    showExpires: showExpired,
  });

  const rpmEnabled =
    enableRPM &&
    Boolean(patientGuid) &&
    (canChangeModule || module === ModuleType.RPM);

  const ccmEnabled =
    enableCCM &&
    Boolean(patientGuid) &&
    (canChangeModule || module === ModuleType.CCM);

  const [rpmQueryData, ccmQueryData] = useQueries({
    queries: [
      {
        queryKey: getKeyNoteKey({
          patientGuid,
          module: ModuleType.RPM,
          showExpired,
        }),
        queryFn: () =>
          getKeyNotes({
            url: urlRPM,
          }),
        enabled: rpmEnabled,
      },
      {
        queryKey: getKeyNoteKey({
          patientGuid,
          module: ModuleType.CCM,
          showExpired,
        }),
        queryFn: () =>
          getKeyNotes({
            url: urlCCM,
          }),
        enabled: ccmEnabled,
      },
    ],
  });
  return [rpmQueryData, ccmQueryData];
};
